export const ROLES = ['CUSTOMER'];
export const DAYS = [
	{ value: 'SUNDAY', label: 'Sunday' },
	{ value: 'MONDAY', label: 'Monday' },
	{ value: 'TUESDAY', label: 'Tuesday' },
	{ value: 'WEDNESDAY', label: 'Wednesday' },
	{ value: 'THURSDAY', label: 'Thursday' },
	{ value: 'FRIDAY', label: 'Friday' },
	{ value: 'SATURDAY', label: 'Saturday' },
];
export const FOOTER_CONFIG = [
	{
		label: "Ausmit",
		key: 'ausmit',
		class: "col-xs-12 col-sm-2 col-md-2",
		options: [
			{ key: '', value: "About Us", route: "aboutus" },
			{ key: '', value: "Terms & Condition", route: "termsandconditions" },
			{ key: '', value: "Privacy Policy", route: "privacypolicy" },
			{ key: '', value: "Return & Refunds Policy", route: "randrypolicy" },
			{ key: '', value: "Shipping Policy", route: "shippingypolicy" },
			{ key: '', value: "Cancellation Policy", route: "cancelpolicy" }
		]
	},
	{
		label: "Customer Service",
		key: 'customer-service',
		class: "col-xs-12 col-sm-3 col-md-3",
		options: [
			{ key: '', value: "Help & Contact", route: "help" },
			{ key: '', value: "Faq", route: "faq" }
			// {key : '', value : "Returns", route:"help"},
			// {key : '', value : "Delivery Information", route:"help"},
			// {key : '', value : "Payment Option", route:"help"}
		]
	},
	{
		label: "Account",
		key: 'account',
		class: "col-xs-12 col-sm-2 col-md-2",
		options: [
			{ key: '', value: "Login", route: "login" },
			{ key: '', value: "Seller Login", route: "https://seller.ausmit.in", redirect: true },
			{ key: '', value: "Register", route: "register" },
			{ key: '', value: "Wishlist", route: "wishlist" },
		]
	}
];

export interface ButtonType { key: string; label: string };
